import {
    SmtpAuthenticationType,
    UserMailboxProvider,
    UserMailboxStatus,
} from "generated/graphql";

export const showsOutlookSendConsent = (
    authenticationType: SmtpAuthenticationType | null,
): boolean =>
    authenticationType === null || authenticationType === SmtpAuthenticationType.Graph;

export const showsOutlookMailboxSyncConsent = (
    provider: UserMailboxProvider | null,
): boolean => provider !== UserMailboxProvider.Gmail;

const isPendingStatus = (status: UserMailboxStatus): boolean =>
    status === UserMailboxStatus.Authenticating ||
    status === UserMailboxStatus.Authenticated;

export const findShownMailbox = <T extends { status: UserMailboxStatus }>(
    mailboxes: readonly T[],
): T | null =>
    mailboxes.find(m => m.status === UserMailboxStatus.Active) ??
    mailboxes.find(m => isPendingStatus(m.status)) ??
    mailboxes.find(m => m.status === UserMailboxStatus.Disconnected) ??
    null;
